import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { referralClient } from "@core/clients";
import { Invitation } from "@core/types";

type TParams = {
  options?: UseQueryOptions<Invitation[], any, Invitation[], any>;
};

const useGetInvitationsQuery = (config: TParams = {}): UseQueryResult<Invitation[], any> => {
  return useQuery(
    ["invitations"],
    async () => {
      const data = await referralClient.getInvitations();
      return data;
    },
    {
      ...config?.options,
    }
  );
};

export default useGetInvitationsQuery;
